import React, { useContext } from 'react';

import cx from 'classnames';

import { AppContext } from 'lane-shared/contexts';

import Loading from './Loading';
import ModalBackground from './ModalBackground';

import styles from './ThemeBlockingLoad.scss';

export function ThemeBlockingLoad() {
  const appContext = useContext(AppContext);
  const { isThemeBlockingLoad } = appContext;

  if (!isThemeBlockingLoad) {
    return null;
  }

  return (
    <ModalBackground
      className={cx(styles.blockingLoad)}
      isOpen={isThemeBlockingLoad}
      onClose={() => undefined}
    >
      <Loading />
    </ModalBackground>
  );
}
